import IMenuItem from "@into-discovery/browsewebshared/src/models/header/IMenuItem";

export type MenuItemsConfig = {
  currentLocale: string;
  children?: IMenuItem[];
};

export function getSubmenuURLs(config: MenuItemsConfig, countryCode: string, children: IMenuItem[]): IMenuItem[] {
  const courses = {
    translationKey: `${countryCode === "US" ? "degrees" : "programmes"}`,
    children
  };

  const submenuItems = [courses];

  return submenuItems;
}

export function getLegalURLs(config: MenuItemsConfig): IMenuItem[] {
  const privacy = {
    url: `/${config.currentLocale}/legal-and-privacy-policy/into`,
    translationKey: "footer.link.privacy"
  };

  const terms = {
    url: `/${config.currentLocale}/terms`,
    translationKey: "footer.link.terms"
  };

  const cookiesPolicy = {
    url: `/${config.currentLocale}/legal-and-privacy-policy/cookies-policy`,
    translationKey: "footer.link.cookies-policy"
  };

  const governance = {
    url: `${process.env.NEXT_PUBLIC_INTO_STUDY_URL}/${config.currentLocale}/governance`,
    translationKey: "footer.link.governance"
  };

  const accessibility = {
    url: `${process.env.NEXT_PUBLIC_INTO_STUDY_URL}/${config.currentLocale}/accessibility-statement`,
    translationKey: "footer.link.accessibility"
  };

  const items = [privacy, terms, cookiesPolicy, governance, accessibility];

  return items;
}

// TODO: Refactor this, use i18n-config.ts
export const localesList = [
  {
    text: "En",
    value: "en"
  },
  {
    text: "中文",
    value: "zh"
  }
];
